import React from 'react';

import { BlogProps } from './Blog.types';

export const Blog: React.FC<BlogProps> = ({}) => {
  return <>Blog</>;
};
